"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DISPLAY_UNIT_CODE = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _CardActions = _interopRequireDefault(require("@mui/material/CardActions"));
var _DialogActions = _interopRequireDefault(require("@mui/material/DialogActions"));
var _DialogContent = _interopRequireDefault(require("@mui/material/DialogContent"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _styles = require("@mui/material/styles");
var _CustomRouter = require("../../components/system/CustomRouter");
var _APIs = require("../../constants/APIs");
var _CodeConsts = require("../../constants/CodeConsts");
var _labelConsts = require("../../constants/labelConsts");
var _coreConfirmActions = require("../../reducers/coreConfirmActions");
var _coreInfoBarActions = require("../../reducers/coreInfoBarActions");
var _CButton = _interopRequireDefault(require("../materials/CButton"));
var _CDialog = _interopRequireDefault(require("../materials/CDialog"));
var _CLabel = _interopRequireDefault(require("../materials/CLabel"));
var _CMultiToggle = _interopRequireDefault(require("../materials/CMultiToggle"));
var _ListIconButton = _interopRequireDefault(require("../materials/ListIconButton"));
var _CallAPI = require("../system/CallAPI");
var _FileInfoParts = _interopRequireDefault(require("./document/FileInfoParts"));
var _TargetParts = _interopRequireDefault(require("./document/TargetParts"));
var _UploadInputParts = _interopRequireDefault(require("./document/UploadInputParts"));
var _UploadResultParts = _interopRequireDefault(require("./document/UploadResultParts"));
var _useRHFForm = require("01_core/validation/useRHFForm");
var Yup = _interopRequireWildcard(require("yup"));
var _validationHelpers = require("01_core/validation/validationHelpers");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const InfoText = (0, _styles.styled)(_Typography.default)(_ref => {
  let {
    theme
  } = _ref;
  return {
    color: theme.palette.infomation.primary,
    fontSize: theme.typography.body2.fontSize,
    fontWeight: 'bold'
  };
});
const ActionItem = (0, _styles.styled)(_Grid.default)(_ref2 => {
  let {
    theme
  } = _ref2;
  return {
    marginLeft: theme.spacing(2)
  };
});
const DISPLAY_UNIT_CODE = exports.DISPLAY_UNIT_CODE = {
  UPLOAD: '1',
  DELETE: '2'
};

/**
 *ドキュメントアップロード／削除
 * @prop {bool} [isButton] - ボタンの場合はtrue、アイコンの場合はfalse default:false
 * @prop {string} siteKindCd - 管理サイト種別コード
 * @prop {string} targetCd - 対象コード
 * @prop {string} bcmKaishaSoshikiCd - BCM会社組織コード
 * @prop {string} bcpTgtJigyoCd - BCP対象事業コード
 * @prop {string} documentKindCd - ドキュメント種別コード
 * @prop {string} [trainingName] - 訓練名（「訓練」の場合のみ使用）
 * @prop {string} [implementationPeriod] - 実施時期（「発動後レビュー」の場合のみ使用）
 * @prop {string} [kaishaSoshikiNm] - 会社／組織（「お問い合わせ」以外の場合のみ使用）
 * @prop {string} [bcpTgtJigyoNm] - BCP対象事業（「お問い合わせ」以外の場合のみ使用）
 * @prop {string} [documentKindNm] - 対象ドキュメント（「お問い合わせ」以外の場合のみ使用）
 * @prop {string} [className] - 指定するclassName
 * @prop {function} [onChange] - 変更されたデータを受け取る関数（ファイルリンクを併用する場合に使用）
 * シグネチャ：({fileNm:string, note:string, updDt:string}):void
 */
const DocumentUploadDelete = props => {
  var _errors$uploadFile, _errors$versionCnt, _errors$note;
  const {
    intl,
    isButton,
    siteKindCd,
    documentKindCd,
    trainingName,
    implementationPeriod,
    kaishaSoshikiNm,
    bcpTgtJigyoNm,
    documentKindNm,
    className,
    callAPI,
    callAPIMultipart,
    openInfoBar,
    openConfirm,
    onChange
  } = props;
  const [isDialogOpen, setIsDialogOpen] = (0, _react.useState)(false);
  const [isComplete, setIsComplete] = (0, _react.useState)(false);
  const [isDispMultiToggle, setIsDispMultiToggle] = (0, _react.useState)(true);
  const [fileInfo, setFileInfo] = (0, _react.useState)({
    fileNm: '',
    note: '',
    updDt: ''
  });
  const [uploadResult, setUploadResult] = (0, _react.useState)({
    fileNm: '',
    note: '',
    updDt: ''
  });
  const childRef = (0, _react.useRef)(null);
  const defaultValues = (0, _react.useMemo)(() => ({
    selectUnit: DISPLAY_UNIT_CODE.UPLOAD,
    uploadFile: null,
    versionCnt: '',
    note: '',
    siteKindCd: siteKindCd,
    documentKindCd: documentKindCd
  }), [siteKindCd, documentKindCd]);
  const schema = (0, _react.useMemo)(() => {
    return Yup.object({
      selectUnit: Yup.string().required(),
      siteKindCd: Yup.string().required(),
      documentKindCd: Yup.string().required(),
      uploadFile: (0, _validationHelpers.requiredFileWhen)(intl, ['selectUnit'], su => su === DISPLAY_UNIT_CODE.UPLOAD),
      versionCnt: (0, _validationHelpers.requiredDigitsExactWhen)(intl, ['selectUnit', 'siteKindCd', 'documentKindCd'], (su, sk, dk) => su === DISPLAY_UNIT_CODE.UPLOAD && sk !== _CodeConsts.CODE.SITE_KIND_CD.CODE_00 && dk !== 'ANK' && dk !== 'SUP', 3, {
        patternMessageId: _labelConsts.LABEL.CORE_DOCUMENT_EDITION_NUMBER_MESSAGE
      }),
      note: (0, _validationHelpers.optionalStringTrimMax)(intl, 30)
    });
  }, [intl]);
  const {
    handleSubmit,
    setValue,
    reset,
    watch,
    formState: {
      errors
    }
  } = (0, _useRHFForm.useRHFForm)({
    defaultValues,
    shape: schema
  });
  const selectUnit = watch('selectUnit');
  const uploadFile = watch('uploadFile');
  const versionCnt = watch('versionCnt');
  const note = watch('note');
  const openDialog = (0, _react.useCallback)(() => {
    setIsComplete(false);
    setIsDispMultiToggle(true);
    setFileInfo({
      fileNm: '',
      note: '',
      updDt: ''
    });
    setUploadResult({
      fileNm: '',
      note: '',
      updDt: ''
    });
    reset(defaultValues);
    setIsDialogOpen(true);
    const sendData = {
      siteKindCd: siteKindCd,
      targetCd: props.targetCd,
      bcmKaishaSoshikiCd: props.bcmKaishaSoshikiCd,
      bcpTgtJigyoCd: props.bcpTgtJigyoCd,
      documentKindCd: documentKindCd
    };
    //アップロード済みファイル情報／削除ファイル情報の取得
    callAPI(_APIs.DOCUMENTMNG_SEARCH, sendData).then(response => {
      if (response.status === _APIs.STATUS.SUCCESS) {
        let disp = true;
        if (!response.data.fileNm) {
          // アップロード済みファイルがない場合、マルチトグルを非表示にする
          disp = false;
        }
        setFileInfo(response.data);
        setIsDispMultiToggle(disp);
        setValue('versionCnt', response.data.nextVersionCnt, {
          shouldValidate: false,
          shouldDirty: false
        });
      }
    });
  }, [callAPI, documentKindCd, siteKindCd, props.targetCd, props.bcmKaishaSoshikiCd, props.bcpTgtJigyoCd, reset, defaultValues, setValue]);
  const closeDialog = (0, _react.useCallback)(() => {
    setIsDialogOpen(false);
    if (onChange) {
      onChange({
        fileNm: uploadResult.fileNm,
        note: uploadResult.note,
        updDt: uploadResult.updDt
      });
    }
  }, [onChange, uploadResult]);
  const cancelDialog = (0, _react.useCallback)(() => {
    setIsDialogOpen(false);
  }, []);
  const onValid = (0, _react.useCallback)(() => {
    if (selectUnit === DISPLAY_UNIT_CODE.UPLOAD) {
      openConfirm(intl.formatMessage({
        id: _labelConsts.LABEL.CORE_CONFIRM
      }), intl.formatMessage({
        id: _labelConsts.LABEL.CORE_UPDATE_CONFIRM_MESSAGE
      }), () => {
        const sendData = new FormData();
        sendData.append('siteKindCd', siteKindCd);
        sendData.append('targetCd', props.targetCd);
        sendData.append('bcmKaishaSoshikiCd', props.bcmKaishaSoshikiCd);
        sendData.append('bcpTgtJigyoCd', props.bcpTgtJigyoCd);
        sendData.append('documentKindCd', documentKindCd);
        sendData.append('versionCnt', versionCnt !== null && versionCnt !== void 0 ? versionCnt : '');
        sendData.append('note', note !== null && note !== void 0 ? note : '');
        sendData.append('uploadFile', uploadFile);
        callAPIMultipart(_APIs.DOCUMENTMNG_UPLOAD, sendData).then(response => {
          if (response.status === _APIs.STATUS.SUCCESS) {
            setIsComplete(true);
            setUploadResult({
              fileNm: response.data.uploadFileNm,
              note: response.data.note,
              updDt: response.data.updDt
            });
          } else {
            openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, response.message);
            if (childRef.current !== null) {
              childRef.current.reSet();
            }
          }
        });
      });
    } else if (selectUnit === DISPLAY_UNIT_CODE.DELETE) {
      openConfirm(intl.formatMessage({
        id: _labelConsts.LABEL.CORE_CONFIRM
      }), intl.formatMessage({
        id: _labelConsts.LABEL.CORE_DELETE_CONFIRM_MESSAGE
      }), () => {
        const sendData = {
          siteKindCd: siteKindCd,
          targetCd: props.targetCd,
          bcmKaishaSoshikiCd: props.bcmKaishaSoshikiCd,
          bcpTgtJigyoCd: props.bcpTgtJigyoCd,
          documentKindCd: documentKindCd
        };
        callAPI(_APIs.DOCUMENTMNG_DELETE, sendData).then(response => {
          if (response.status === _APIs.STATUS.SUCCESS) {
            setIsComplete(true);
          } else {
            openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, response.message);
          }
        });
      });
    }
  }, [selectUnit, openConfirm, intl, siteKindCd, documentKindCd, props.targetCd, props.bcmKaishaSoshikiCd, props.bcpTgtJigyoCd, callAPIMultipart, openInfoBar, versionCnt, note, uploadFile, callAPI]);
  const onInvalid = (0, _react.useCallback)(() => {
    openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, intl.formatMessage({
      id: _labelConsts.LABEL.CORE_VALIDATE_MESSAGE
    }));
  }, [openInfoBar, intl]);
  const changeMultiToggle = (0, _react.useCallback)(value => {
    setValue('selectUnit', value, {
      shouldValidate: false,
      shouldDirty: false
    });
  }, [setValue]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isButton ? /*#__PURE__*/_react.default.createElement(_CButton.default, {
    autoWidth: true,
    onClick: openDialog,
    className: className
  }, intl.formatMessage({
    id: _labelConsts.LABEL.CORE_CONTACT_INFORMATION_UPDATE
  })) : /*#__PURE__*/_react.default.createElement(_ListIconButton.default, {
    action: "upload",
    onClick: openDialog
  }), /*#__PURE__*/_react.default.createElement(_CDialog.default, {
    title: isComplete ? intl.formatMessage({
      id: _labelConsts.LABEL.CORE_DOCUMENT_UPLOAD_DELETE_COMPLETE
    }) : intl.formatMessage({
      id: _labelConsts.LABEL.CORE_DOCUMENT_UPLOAD_DELETE
    }),
    open: isDialogOpen,
    handleClose: () => {
      if (isComplete) {
        closeDialog();
      } else {
        cancelDialog();
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_DialogContent.default, null, /*#__PURE__*/_react.default.createElement("form", {
    noValidate: true,
    onSubmit: handleSubmit(onValid, onInvalid)
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true
  }, isComplete && /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12
    }
  }, /*#__PURE__*/_react.default.createElement(InfoText, null, selectUnit === DISPLAY_UNIT_CODE.DELETE ? intl.formatMessage({
    id: _labelConsts.LABEL.CORE_FILE_DELETE_COMPLETE
  }) : intl.formatMessage({
    id: _labelConsts.LABEL.CORE_FILE_UPLOAD_COMPLETE
  }))), siteKindCd !== _CodeConsts.CODE.SITE_KIND_CD.CODE_00 && /*#__PURE__*/_react.default.createElement(_TargetParts.default, {
    title: selectUnit === DISPLAY_UNIT_CODE.DELETE ? intl.formatMessage({
      id: _labelConsts.LABEL.CORE_DELETE_TARGET
    }) : intl.formatMessage({
      id: _labelConsts.LABEL.CORE_UPLOAD_TARGET
    }),
    siteKindCd: siteKindCd,
    trainingName: trainingName,
    implementationPeriod: implementationPeriod,
    kaishaSoshikiNm: kaishaSoshikiNm,
    bcpTgtJigyoNm: bcpTgtJigyoNm,
    documentKindNm: documentKindNm
  }), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (() => {
    if (!isComplete || isComplete && selectUnit === DISPLAY_UNIT_CODE.DELETE) {
      return /*#__PURE__*/_react.default.createElement(_FileInfoParts.default, {
        title: selectUnit === DISPLAY_UNIT_CODE.DELETE ? intl.formatMessage({
          id: _labelConsts.LABEL.CORE_DELETED_FILE_INFORMATION
        }) : intl.formatMessage({
          id: _labelConsts.LABEL.CORE_UPLOADED_FILE_INFORMATION
        }),
        fileInfo: fileInfo
      });
    }
  })()), !isComplete && siteKindCd !== _CodeConsts.CODE.SITE_KIND_CD.CODE_00 && isDispMultiToggle && /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 6
    }
  }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.CORE_UPLOAD_DELETE
    }),
    required: true
  }, /*#__PURE__*/_react.default.createElement(_CMultiToggle.default, {
    options: [{
      displayName: intl.formatMessage({
        id: _labelConsts.LABEL.CORE_UPLOAD
      }),
      value: DISPLAY_UNIT_CODE.UPLOAD
    }, {
      displayName: intl.formatMessage({
        id: _labelConsts.LABEL.CORE_DELETE
      }),
      value: DISPLAY_UNIT_CODE.DELETE
    }],
    selectedOption: selectUnit,
    onSelectOption: changeMultiToggle
  }))), !isComplete && selectUnit === DISPLAY_UNIT_CODE.UPLOAD && /*#__PURE__*/_react.default.createElement(_UploadInputParts.default, {
    onRef: ref => childRef.current = ref,
    siteKindCd: siteKindCd,
    documentKindCd: documentKindCd,
    onChangeEntry: key => value => setValue(key, value, {
      shouldValidate: false,
      shouldDirty: false
    }),
    uploadEntry: {
      uploadFile,
      versionCnt,
      note
    },
    fileError: !!errors.uploadFile,
    fileHelperText: (_errors$uploadFile = errors.uploadFile) === null || _errors$uploadFile === void 0 ? void 0 : _errors$uploadFile.message,
    versionCntError: !!errors.versionCnt,
    versionCntHelperText: (_errors$versionCnt = errors.versionCnt) === null || _errors$versionCnt === void 0 ? void 0 : _errors$versionCnt.message,
    noteError: !!errors.note,
    noteHelperText: (_errors$note = errors.note) === null || _errors$note === void 0 ? void 0 : _errors$note.message
  }), isComplete && selectUnit === DISPLAY_UNIT_CODE.UPLOAD && /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12
    }
  }, /*#__PURE__*/_react.default.createElement(_UploadResultParts.default, {
    uploadResult: uploadResult
  }))), isComplete ? /*#__PURE__*/_react.default.createElement(_DialogActions.default, null, /*#__PURE__*/_react.default.createElement(_CardActions.default, null, /*#__PURE__*/_react.default.createElement(ActionItem, null, /*#__PURE__*/_react.default.createElement(_CButton.default, {
    autoWidth: true,
    negative: true,
    onClick: closeDialog
  }, props.intl.formatMessage({
    id: _labelConsts.LABEL.CORE_CLOSE
  }))))) : /*#__PURE__*/_react.default.createElement(_DialogActions.default, null, /*#__PURE__*/_react.default.createElement(_CardActions.default, null, /*#__PURE__*/_react.default.createElement(ActionItem, null, /*#__PURE__*/_react.default.createElement(_CButton.default, {
    autoWidth: true,
    negative: true,
    onClick: cancelDialog
  }, props.intl.formatMessage({
    id: _labelConsts.LABEL.CORE_CANCEL
  }))), /*#__PURE__*/_react.default.createElement(ActionItem, null, /*#__PURE__*/_react.default.createElement(_CButton.default, {
    submit: true,
    autoWidth: true
  }, props.intl.formatMessage({
    id: _labelConsts.LABEL.CORE_RUN
  })))))))));
};
DocumentUploadDelete.propTypes = {
  isButton: _propTypes.default.bool,
  siteKindCd: _propTypes.default.string.isRequired,
  targetCd: _propTypes.default.string.isRequired,
  bcmKaishaSoshikiCd: _propTypes.default.string.isRequired,
  bcpTgtJigyoCd: _propTypes.default.string.isRequired,
  documentKindCd: _propTypes.default.string.isRequired,
  trainingName: _propTypes.default.string,
  implementationPeriod: _propTypes.default.string,
  kaishaSoshikiNm: _propTypes.default.string,
  bcpTgtJigyoNm: _propTypes.default.string,
  documentKindNm: _propTypes.default.string,
  className: _propTypes.default.string,
  onChange: _propTypes.default.func
};
const mapDispatchToProps = dispatch => {
  return {
    openInfoBar: (type, message) => dispatch(_coreInfoBarActions.coreInfoBarActions[_coreInfoBarActions.TYPES_INFO_BAR.OPEN](type, message)),
    openConfirm: (title, message, onClickOk) => dispatch(_coreConfirmActions.coreConfirmActions[_coreConfirmActions.TYPES_CONFIRM.OPEN](title, message, onClickOk))
  };
};
var _default = exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)((0, _reactIntl.injectIntl)((0, _CustomRouter.withRouter)((0, _CallAPI.withCallAPI)(DocumentUploadDelete))));